import Swal from 'sweetalert2';

export const commonToast = (
  type: 'success' | 'error' | 'warning' | 'info' | 'question',
  title: string
): void => {
  Swal.fire({
    toast: true,
    position: 'bottom-end',
    icon: type,
    title,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      const container = (toast as HTMLElement)?.closest?.('.swal2-container');
      if (container instanceof HTMLElement) {
        container.style.setProperty('z-index', '20000', 'important');
      }
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
};
